export enum PurchaseOrderSteps {
    Overview = 0,
    Positions = 1,
    /** The chain the order belongs to (#2160): read only, nothing to fill in. */
    Documents = 2,
}
